import { getLogger } from './logger-instance';

function handleWindowError(event: ErrorEvent): void {
  // ErrorEvent uses '' / 0 to mean "position unavailable"; omit those.
  getLogger({ scope: 'app.global-error' }).error('Uncaught error', {
    error: event.error ?? new Error(event.message),
    attributes: {
      'code.filepath': event.filename || undefined,
      'code.lineno': event.lineno > 0 ? event.lineno : undefined,
      'code.column': event.colno > 0 ? event.colno : undefined,
    },
  });
}

function handleUnhandledRejection(event: PromiseRejectionEvent): void {
  const reason =
    event.reason instanceof Error
      ? event.reason
      : new Error(typeof event.reason === 'string' ? event.reason : String(event.reason));

  getLogger({ scope: 'app.unhandled-rejection' }).error('Unhandled promise rejection', {
    error: reason,
  });
}

let installed = false;

export function installGlobalErrorHandlers(): void {
  if (installed || typeof window === 'undefined') {
    return;
  }
  installed = true;
  window.addEventListener('error', handleWindowError);
  window.addEventListener('unhandledrejection', handleUnhandledRejection);
}

export function uninstallGlobalErrorHandlers(): void {
  if (!installed || typeof window === 'undefined') {
    return;
  }
  installed = false;
  window.removeEventListener('error', handleWindowError);
  window.removeEventListener('unhandledrejection', handleUnhandledRejection);
}
